import { EMAIL_PATTERN } from '@avanta/shared/constants/patterns';
import { isValidPhoneNumber } from 'react-phone-number-input';

export const validateSapaContactValue = (value: string): string | null => {
  const trimmed = value.trim();
  if (!trimmed) return null;

  const hasLettersOrAt = /[a-zA-Z]/.test(trimmed) || trimmed.includes('@');
  if (hasLettersOrAt) {
    const isEmailFormat = EMAIL_PATTERN.test(trimmed);
    return isEmailFormat ? null : 'SignupForm.emailError';
  }

  const normalizedPhone = trimmed.startsWith('+') ? trimmed : `+34${trimmed}`;
  const digitCount = trimmed.replace(/\D/g, '').length;
  if (digitCount < 2) return null;

  const isPhoneFormat = isValidPhoneNumber(normalizedPhone);
  return isPhoneFormat ? null : 'Common.phone.error';
};
